import { createStore } from 'vuex'
//------------------------------------------------------------
const CONFIG = { expires: 1, secure: true, httpOnly: true }
//------------------------------------------------------------
const store = createStore({
  state:{
    lang: localStorage.getItem('lang') || 'ar',
  },
  getters:{
    lang: state => state.lang,
  },
  mutations: {
    lang (state, lang) {
      state.lang = lang;
      localStorage.setItem('lang', lang, CONFIG);
    },
    clearAll(state) {
      state.lang = 'ar';
      localStorage.removeItem('lang');
    },
  },
  actions:{
    lang({commit}, data){
      commit('lang', data);
    },
    clearAll({commit}){
      commit('clearAll');
    }
  }
})
export default store;
